// extracted by mini-css-extract-plugin
export default {"About":"About_About__LeFbV","image":"About_image__EorJG","text":"About_text__q-vdH"};